(() => {
  'use strict';

  document.querySelectorAll('[data-pacific-product]').forEach((root) => {
    const jsonEl = root.querySelector('[data-pacific-product-json]');
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.error('Pacific product data could not be read.', error);
      return;
    }

    const image = root.querySelector('[data-product-main-image]');
    const price = root.querySelector('[data-variant-price]');
    const sku = root.querySelector('[data-variant-sku]');
    const stock = root.querySelector('[data-variant-stock]');
    const selection = root.querySelector('[data-variant-selection]');
    const customize = root.querySelector('[data-customize-button]');
    const colorSelect = root.querySelector('[data-color-select]');
    const sizeButtons = [...root.querySelectorAll('[data-size-value]')];
    const thumbnails = [...root.querySelectorAll('[data-product-thumbnail]')];

    function formatColorDisplay(raw) {
      if (!raw) return '';
      const capitalizeWord = (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      return raw
        .split('/')
        .map((part) => part.trim().split(' ').filter(Boolean).map(capitalizeWord).join(' '))
        .join(' / ');
    }

    let selectedColor = colorSelect?.value || data.variants[0]?.color || '';
    let selectedSize = sizeButtons.find((button) => button.classList.contains('is-selected'))?.dataset.sizeValue || data.variants[0]?.size || '';

    function variantsForColor(color) {
      return data.variants.filter((variant) => !color || variant.color === color);
    }

    function findVariant() {
      return data.variants.find((variant) => {
        const colorMatch = !selectedColor || variant.color === selectedColor;
        const sizeMatch = !selectedSize || variant.size === selectedSize;
        return colorMatch && sizeMatch;
      }) || variantsForColor(selectedColor)[0] || data.variants[0];
    }

    function syncSizeButtons() {
      if (!sizeButtons.length) return;
      const allowed = new Set(variantsForColor(selectedColor).map((variant) => variant.size));
      sizeButtons.forEach((button) => {
        const allowedSize = allowed.has(button.dataset.sizeValue);
        button.disabled = !allowedSize;
        button.classList.toggle('is-unavailable', !allowedSize);
      });

      if (!allowed.has(selectedSize)) {
        const first = sizeButtons.find((button) => allowed.has(button.dataset.sizeValue));
        if (first) selectedSize = first.dataset.sizeValue;
      }
    }

    function syncControls() {
      if (colorSelect && colorSelect.value !== selectedColor) {
        colorSelect.value = selectedColor;
      }
      sizeButtons.forEach((button) => {
        const active = button.dataset.sizeValue === selectedSize;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function builderUrl(variant) {
      const url = new URL(data.builderUrl, window.location.origin);
      url.searchParams.set('categoryName', 'custom headwear');
      url.searchParams.set('styleId', data.style);
      url.searchParams.set('partNumber', data.style);
      url.searchParams.set('style', data.style);
      if (variant.colorCode) {
        url.searchParams.set('capColorCode', variant.colorCode);
        url.searchParams.set('color', variant.colorCode);
      }
      if (variant.color) url.searchParams.set('colorName', variant.color);
      if (variant.sku) url.searchParams.set('sku', variant.sku);
      return url.pathname + url.search;
    }

    function render() {
      syncSizeButtons();
      const variant = findVariant();
      if (!variant) return;

      selectedColor = variant.color || selectedColor;
      selectedSize = variant.size || selectedSize;
      syncControls();

      if (price) price.textContent = variant.priceFormatted || '';
      if (sku) sku.textContent = variant.sku || '—';
      if (selection) selection.textContent = [formatColorDisplay(variant.color), variant.size].filter(Boolean).join(' / ');

      const quantity = Number(variant.inventory || 0);
      if (stock) {
        stock.textContent = quantity > 0 ? `In stock: ${quantity.toLocaleString()}` : 'Currently out of stock';
        stock.dataset.state = quantity > 0 ? 'in' : 'out';
      }

      if (image && variant.imageUrl) {
        image.src = variant.imageUrl;
        image.alt = `Pacific Headwear ${data.style} ${data.title} in ${formatColorDisplay(variant.color) || 'selected color'}`;
      }

      if (customize) customize.href = builderUrl(variant);

      try {
        const pageUrl = new URL(window.location.href);
        if (variant.id) pageUrl.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', pageUrl);
      } catch (_) {}
    }

    if (colorSelect) {
      colorSelect.addEventListener('change', () => {
        selectedColor = colorSelect.value || '';
        render();
      });
    }

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        selectedSize = button.dataset.sizeValue || '';
        render();
      });
    });

    thumbnails.forEach((button) => {
      button.addEventListener('click', () => {
        if (!image || !button.dataset.image) return;
        image.src = button.dataset.image;
        image.alt = button.dataset.alt || image.alt;
        thumbnails.forEach((thumb) => thumb.classList.toggle('is-selected', thumb === button));
      });
    });

    render();
  });
})();
